import React from 'react'

export const scrollToTop = () => {
    window.scrollTo(0, 0)
}